import { Pipe, PipeTransform } from '@angular/core';

import { CountNumberOfPositionsBOMPipe } from './count-number-of-positions-bom.pipe';
import { CanTransferToWholesalerPipe } from './can-transfer-to-wholesaler.pipe';
import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'numberOfBomPositions',
    standalone: false
})
export class NumberOfBomPositionsPipe implements PipeTransform {

  transform(bomModels: IBomModel[],
            bomModelsAccessories: IBomModel[],
            selectedItems: number[],
            selectedItemsAccessories: number[]): number {

    return new CountNumberOfPositionsBOMPipe().transform(
      selectedItems,
      new CanTransferToWholesalerPipe().transform(bomModels),
      new CanTransferToWholesalerPipe().transform(bomModelsAccessories),
      selectedItemsAccessories
    )
  }

}
